import {
  Card,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListSubheader,
} from '@mui/material';
import ListItemText from '@mui/material/ListItemText';
import React from 'react';
import { ChevronRight as ChevronRightIcon } from 'react-feather';
import { useNavigate } from 'react-router-dom';

import Breadcrumb from '@/components/common/breadcrumb.component';

const SettingsView = () => {
  const navigate = useNavigate();
  return (
    <div>
      <Breadcrumb title="Settings" label="Settings" />

      <div className="container-fluid">
        <div
          style={{
            maxWidth: 800,
            width: '100%',
            margin: '30px auto',
          }}
        >
          <Card
            style={{
              maxWidth: 1200,
              width: '100%',
              margin: '30px auto',
            }}
          >
            <List
              subheader={
                <ListSubheader
                  style={{
                    color: '#d3a966',
                    fontSize: 16,
                    fontWeight: 600,
                  }}
                >
                  {'Team & Permissions'}
                </ListSubheader>
              }
            >
              <ListItem onClick={() => navigate('/settings/users')} style={{ cursor: 'pointer' }}>
                <ListItemText primary="Manage Team" />
                <ListItemSecondaryAction>
                  <ChevronRightIcon
                    style={{ height: 18, width: 18, marginLeft: 10, cursor: 'pointer' }}
                  />
                </ListItemSecondaryAction>
              </ListItem>
              <ListItem onClick={() => navigate('/settings/roles')} style={{ cursor: 'pointer' }}>
                <ListItemText primary="Manage Roles" />
                <ListItemSecondaryAction>
                  <ChevronRightIcon
                    style={{ height: 18, width: 18, marginLeft: 10, cursor: 'pointer' }}
                  />
                </ListItemSecondaryAction>
              </ListItem>
            </List>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default SettingsView;
